import React from "react";
import { Card } from "baseui/card";
import { Button } from "baseui/button";
import HeadingSection from "../components/Heading";
import { useNavigate } from "react-router-dom";
import CheckIcon from '../assets/check-icon.svg';
import { UserContext } from '../App';


const PaymentSuccessPage = () => {
    let navigate = useNavigate();
    let { setValue } = React.useContext(UserContext);

    let setNewFlow = ()=>{
        localStorage.setItem("cache", JSON.stringify({
            name:"",
            orcaAPIKey: "",
            uid: "",
            selectedPg: "",
            selectedPgs: []
        }))
        setValue("name", "")
        setValue("uid", "")
        setValue("orcaAPIKey", "")
        setValue("selectedPg", "")
        setValue("selectedPgs", [])
        navigate("/")
    }

  return (
    <div style={{ height: "400px" }} className='w-full max-w-lg mx-auto' >
            <Card>
                <div className='p-5' >
                    <div className="w-full flex justify-center mb-5" > <img className="w-14 h-14 text-green-500" src={CheckIcon} alt=""  /></div>
                    <HeadingSection iconEnabled={false} headerClass="mb-10" title={"Payment Successful!"} backUrl={"/"} />
                    <div className="w-full flex justify-center" >
                    <div className="ml-1 mb-7 font-bold text-gray-600" ><div className="text-4xl mt-1 text-black" > $500.0</div>Payment amount:</div>
                    </div>
                   
                    <div className='mt-5' >
                        <Button style={{ width: "100%" }}  onClick={setNewFlow}>Done</Button>
                    </div>
                </div>
            </Card>
        </div>
  )
}

export default PaymentSuccessPage